import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { fmtErr, isDesk } from "@/lib/api";
import { AuthShell, Field } from "@/components/AuthShell";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = await login(form.email, form.password);
      nav(loc.state?.from || (isDesk(u) ? "/desk" : "/"));
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell kicker="Readers · Newsroom" title="Sign in">
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <Field label="Email">
          <Input data-testid="login-email-input" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="rounded-none h-11 bg-white" />
        </Field>
        <Field label="Password">
          <Input data-testid="login-password-input" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="rounded-none h-11 bg-white" />
        </Field>
        {error && <p data-testid="login-error" className="text-sm text-[#DC2626] border-l-2 border-[#DC2626] pl-3">{error}</p>}
        <Button data-testid="login-submit-btn" disabled={busy} className="w-full h-11 rounded-none font-bold">{busy ? "Signing in…" : "Sign in"}</Button>
      </form>
      <div className="mt-10 border-t border-zinc-300 pt-6 space-y-2 text-sm">
        <p>New reader? <Link data-testid="login-register-link" to="/register" className="font-bold underline">Create an account</Link> to comment.</p>
      </div>
    </AuthShell>
  );
}
